var overlay = (function () {
	var id = 'spinner_overlay';

	return {
		id: id,
		create: function (target, opt={}) {
			let spinner_content;
			let animationClasses;
			let wrapClass;
			const $ele = rp$(target);

			this.id = 'spinner_overlay';
			if ($ele.attr('id')) {
				this.id += '_'+ $ele.attr('id');
			} else {
				this.id += '_'+ Date.now();
			}

			/* Check to see if element already has a spinner running
			.*-----------------------------------------*/
			if ($ele.find('.spinner-wrap').length > 0) {
				// already spinning - no need to add another spinner
				return;
			}

			animationClasses = 'fa fa-refresh fa-spin';

			wrapClass = 'spinner-wrap';
			if (opt && opt.fixedPosition) {
				wrapClass += ' spinner-fixed';
			}

			spinner_content  = '<div id="'+ this.id +'" class="'+wrapClass+'">';
			spinner_content += '<div class="spinner-overlay"></div>';
			spinner_content += '<div class="spinner-icon"><i class="'+animationClasses+'"></i></div>';
			spinner_content += '</div> <!-- #'+ this.id + '-->';

			$ele.append(spinner_content);

			// Could change this to validate and apply any styles to different
			// parts of the spinner
			if (opt.animation.top) {
				$ele.find('.spinner-icon').css('top', opt.animation.top);
			}
		},
		show: function (callback) {
			rp$('#' + this.id).fadeIn('fast', callback);
		},
		destroy: function () {
			rp$('#' + this.id).fadeOut('fast', function () {
				rp$('#' + this.id).remove();
			});
		}
	};
})();

rp$.fn.overlaySpinner = function (options) {
	var opt = rp$.extend({
		// Defaults
		animation: {
			top: '50%'
		}
	}, options);

	overlay.create(this, opt);
	overlay.show(rp$.noop);

	return this;
};
rp$.fn.overlaySpinner.remove = function () {
	overlay.destroy();
	return this;
};
